import { observable } from 'mobx';

export class AgendamentoModel {
  readonly agendaId: string;
  readonly id: number;

  @observable agendaUrl: string;
  @observable dataFim: Date;
  @observable dataInicio: Date;
  @observable local: string = '';
  @observable localId?: string;
  @observable monografiaId?: number;
  @observable linkEvento?: string
}